const styles = `:host {
  border-width: 1px;
  border-style: solid;
  min-height: 42px;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  padding: 0 12px;
  box-sizing: border-box;
  color: var(--goto-text-01);
  --goto-icon-size: 20px;
}
:host .alert-content {
  color: var(--goto-text-01);
  font: var(--goto-body-small);
  margin: 0;
  padding: 8px 0;
  align-self: center;
  flex-grow: 1;
}
:host .alert-content ::slotted(p) {
  margin: 0 !important;
}
:host ::slotted(chameleon-svg) {
  --goto-icon-margin: 0 12px 0 0;
  margin-top: 10px;
}
:host chameleon-icon-button {
  margin-top: 6px;
}
:host ::slotted([slot=action]) {
  --goto-link-color: var(--goto-text-01);
  --goto-link-text-decoration: underline;
}

:host([variant=info]) {
  background-color: var(--goto-alert-background);
  border-color: var(--goto-alert-border);
  --goto-icon-color: var(--goto-interactive-01);
}

:host([variant=success]) {
  background-color: var(--goto-success-02);
  border-color: var(--goto-text-success-01);
  --goto-icon-color: var(--goto-text-success-01);
}

:host([variant=warning]) {
  background-color: var(--goto-warning-02);
  border-color: var(--goto-warning-01);
  --goto-icon-color: var(--goto-text-warning-01);
}

:host([variant=danger]) {
  background-color: var(--goto-danger-02);
  border-color: var(--goto-text-error-01);
  --goto-icon-color: var(--goto-text-error-01);
}`; export default styles;